import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import FiskLogo from "@/components/FiskLogo";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bem-vindo de volta!");
      navigate("/");
    } else {
      toast.error(res.error || "Erro ao entrar");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="h-16 bg-black flex items-center px-4 sm:px-8">
        <FiskLogo to="/login" />
      </div>
      <div className="flex-1 grid lg:grid-cols-2">
        <div className="hidden lg:flex flex-col justify-between p-12 bg-[#0A0A0A] text-white relative overflow-hidden">
          <div className="absolute inset-0 opacity-10"
               style={{backgroundImage: "radial-gradient(circle at 20% 20%, #E30613 0%, transparent 40%)"}} />
          <div className="relative z-10">
            <p className="text-xs uppercase tracking-[0.3em] text-[#E30613] mb-4">Portal do Aluno</p>
            <h1 className="text-4xl xl:text-5xl font-bold leading-tight tracking-tight">
              Acesse seus áudios e vídeos<br/>
              <span className="text-[#E30613]">de cada curso</span>.
            </h1>
            <p className="mt-6 text-neutral-400 max-w-md leading-relaxed">
              Todo o conteúdo do seu curso em um só lugar. Estude pelo computador ou pelo celular, no seu ritmo.
            </p>
            <p className="mt-6 text-neutral-300 text-sm font-medium leading-tight">
              FISK Sacomã (SP)<br/>FISK Paulicéia (SBC)
            </p>
          </div>
          <div className="relative z-10 text-xs text-neutral-500">
            © {new Date().getFullYear()} FISK — Unidade Sacomã (SP). Todos os direitos reservados.
          </div>
        </div>

        <div className="flex items-center justify-center p-6 sm:p-12">
          <form onSubmit={onSubmit} className="w-full max-w-md space-y-6" data-testid="login-form">
            <div>
              <h2 className="text-3xl font-bold text-neutral-900">Entrar</h2>
              <p className="text-sm text-neutral-500 mt-2">
                Acesse com seu e-mail e senha.
              </p>
            </div>

            <div className="space-y-2">
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                data-testid="login-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                className="rounded-sm"
              />
            </div>
            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <Label htmlFor="password">Senha</Label>
                <Link
                  to="/forgot-password"
                  data-testid="forgot-password-link"
                  className="text-xs text-[#E30613] hover:underline font-medium"
                >
                  Esqueci minha senha
                </Link>
              </div>
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="rounded-sm"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-[#E30613] hover:bg-[#B3040E] text-white rounded-sm h-11 font-semibold"
            >
              {loading ? "Entrando..." : "Entrar"}
            </Button>

            <p className="text-sm text-neutral-600 text-center">
              Ainda não tem cadastro?{" "}
              <Link to="/register" data-testid="go-register-link" className="text-[#E30613] font-medium hover:underline">
                Cadastre-se
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
